import {
  CcfBox,
  CcfButton,
  CcfCloseIcon,
  CcfTextField,
  CcfTypography,
  CcfWemIcon,
} from '@nice-ccf/ui-controls';
import styles from './ccf-wem-dashboard.module.scss';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormGroup,
} from '@mui/material';
import { useEffect, useState } from 'react';

/* eslint-disable-next-line */
export interface CcfWemRequestCoachingDialogProps {
  setIsRequestClicked: any;
  isRequestClicked: any;
  setRequestRowData: any;
  setCurrentTab: any;
  requestRowData: any;
  setShowToast: any;
}

/**
 * CcfWemEvaluations - used to display wem evaluations
 * @param props - CcfWemEvaluations
 * @example `<CcfWemEvaluations />`
 */
export function CcfWemRequestCoachingDialog(
  props: CcfWemRequestCoachingDialogProps
) {
  const {
    setIsRequestClicked,
    isRequestClicked,
    setRequestRowData,
    requestRowData,
    setCurrentTab,
    setShowToast,
  } = props;
  const [inputValue, setInputValue] = useState('');
  const [count, setCount] = useState(0);

  /**@example */
  const getFormattedDate = () => {
    const today = new Date();
    return today.toLocaleDateString('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
    });
  };

  /**@example */
  const handleSendRequest = () => {
    const obj = {
      id: 0,
      focusArea: '-',
      coachName: 'Administrator01 Perm_TestGBU',
      lastUpdated: getFormattedDate(),
      status: 'Request Pending',
      creadedOn: getFormattedDate(),
    };
    // setCount((prevCount: any) => prevCount + 1);
    setRequestRowData((prev: any) => [...prev, obj]);
    setShowToast(true);
    setInputValue('');
    setIsRequestClicked(false);
    setCurrentTab(1);
  };

  return (
    <CcfBox className={styles.requestCoachingContainer}>
      <Dialog
        onClose={() => setIsRequestClicked(false)}
        open={isRequestClicked}
        fullWidth={true}
        maxWidth="lg"
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        sx={{
          '& .MuiDialog-paper': styles.requestCoachingContainer,
        }}
      >
        <DialogTitle
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <CcfTypography
            sx={{
              fontWeight: '600',
              fontSize: '1.25rem',
              textTransform: 'capitalize',
            }}
          >
            Request Coaching
          </CcfTypography>

          <CcfCloseIcon onClick={() => setIsRequestClicked(false)} />
        </DialogTitle>
        <DialogContent className={styles.blockContainer}>
          <CcfBox className={styles.feildBlock}>
            <CcfTypography className={styles.tableHeaderText}>
              Coach Name : Administrator01 Perm_TestGBU
            </CcfTypography>
            <CcfBox style={{ display: 'flex', alignItems: 'center' }}>
              <CcfWemIcon htmlColor={'#526b7a'} viewBox="-2 -4 30 30" />
              <CcfTypography className={styles.tableHeaderText}>
                Request Draft
              </CcfTypography>
            </CcfBox>
          </CcfBox>
          <CcfBox
            style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}
          >
            <CcfTypography
              style={{
                textTransform: 'uppercase',
                fontWeight: '500',
                fontSize: '0.75rem',
              }}
            >
              comment <span style={{ color: 'red' }}>*</span>
            </CcfTypography>
            <CcfTextField
              rows={1}
              id="commentField"
              placeholder="Add Comment"
              name="comment"
              style={{
                minHeight: '16px',
                maxHeight: '64px',
                width: '100%',
                borderRadius: '0.25rem',
                backgroundColor: '#f8f8f9',
              }}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              sx={{
                '& .MuiInputBase-input': { padding: '8px' },
              }}
            />{' '}
            <CcfBox
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                width: '100%',
              }}
            >
              <CcfTypography className={styles.tableHeaderText}>
                {`${inputValue.length}/4000`}
              </CcfTypography>
            </CcfBox>
          </CcfBox>
        </DialogContent>
        <DialogActions>
          <CcfButton
            disabled={inputValue === '' ? true : false}
            className={
              inputValue === '' ? styles.disabledBtn : styles.saveDraftBtn
            }
          >
            Save as Draft
          </CcfButton>
          <CcfButton
            primary={inputValue === '' ? false : true}
            disabled={inputValue === '' ? true : false}
            className={
              inputValue === '' ? styles.disabledBtn : styles.sendReqBtn
            }
            onClick={() => {
              handleSendRequest();
            }}
          >
            Send Request
          </CcfButton>
        </DialogActions>
      </Dialog>
    </CcfBox>
  );
}
